import { useDispatch, useSelector } from 'react-redux'
import { Menu, SlidersHorizontal, Grid2X2, Grid3X3, LayoutGrid } from 'lucide-react'
import { RootState } from '@/store/store'
import { toggleSidebar, toggleFilterPanel, toggleMobileMenu, cycleGridSize } from '@/store/slices/uiSlice'
import { removeTag } from '@/store/slices/filterSlice'
import { SearchBar } from '@/components/search'
import { UserMenu } from '@/auth'

function Header() {
  const dispatch = useDispatch()
  const { activeTags } = useSelector((state: RootState) => state.filter)
  const { filterPanelOpen, gridSize } = useSelector((state: RootState) => state.ui)

  const GridIcon = gridSize === 'small' ? LayoutGrid : gridSize === 'medium' ? Grid3X3 : Grid2X2
  const gridLabel = gridSize === 'small' ? 'Small' : gridSize === 'medium' ? 'Medium' : 'Large'

  return (
    <header className="h-14 border-b border-border bg-card px-4 flex items-center gap-4">
      {/* Mobile Menu Button */}
      <button
        className="md:hidden p-2 hover:bg-secondary rounded-md"
        onClick={() => dispatch(toggleMobileMenu())}
      >
        <Menu size={20} />
      </button>

      {/* Desktop Sidebar Toggle */}
      <button
        className="hidden md:block p-2 hover:bg-secondary rounded-md"
        onClick={() => dispatch(toggleSidebar())}
      >
        <Menu size={20} />
      </button>

      {/* Search Bar */}
      <div className="flex-1 flex items-center gap-2">
        <SearchBar />

        {/* Active Tags */}
        {activeTags.length > 0 && (
          <div className="hidden lg:flex items-center gap-1 flex-shrink-0">
            {activeTags.slice(0, 3).map(tag => (
              <span
                key={tag}
                className="inline-flex items-center gap-1 px-2 py-1 bg-primary/20 text-primary rounded-full text-sm"
              >
                {tag}
                <button
                  onClick={() => dispatch(removeTag(tag))}
                  className="hover:text-primary-foreground"
                >
                  &times;
                </button>
              </span>
            ))}
            {activeTags.length > 3 && (
              <span className="text-sm text-muted-foreground">
                +{activeTags.length - 3} more
              </span>
            )}
          </div>
        )}
      </div>

      {/* Filter Toggle */}
      <button
        className={`p-2 rounded-md transition-colors ${
          filterPanelOpen ? 'bg-primary text-primary-foreground' : 'hover:bg-secondary'
        }`}
        onClick={() => dispatch(toggleFilterPanel())}
      >
        <SlidersHorizontal size={20} />
      </button>

      {/* Grid Size Toggle */}
      <button
        className="p-2 hover:bg-secondary rounded-md"
        onClick={() => dispatch(cycleGridSize())}
        title={`Grid: ${gridLabel} (click to change)`}
      >
        <GridIcon size={20} />
      </button>

      {/* User Menu (renders null when auth disabled) */}
      <UserMenu />
    </header>
  )
}

export default Header
